import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ApiResponse } from '@core/types';
import {
  CommunicationTemplate,
  CommunicationTemplateCreate,
  CommunicationTemplateUpdate,
  CommunicationTemplatePreview,
  CommunicationTemplatePreviewRequest,
  CommunicationTemplateType
} from '@core/types/communication-template.type';

@Injectable({ providedIn: 'root' })
export class CommunicationTemplateService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.api}/configuration/communication-templates`;

  getTemplates(type?: CommunicationTemplateType): Observable<ApiResponse<CommunicationTemplate[]>> {
    const params = type !== undefined ? { type: String(type) } : {};
    return this.http.get<ApiResponse<CommunicationTemplate[]>>(this.apiUrl, { params });
  }

  getTemplate(id: string): Observable<ApiResponse<CommunicationTemplate>> {
    return this.http.get<ApiResponse<CommunicationTemplate>>(`${this.apiUrl}/${id}`);
  }

  createTemplate(data: CommunicationTemplateCreate): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(this.apiUrl, data);
  }

  updateTemplate(data: CommunicationTemplateUpdate): Observable<ApiResponse<void>> {
    return this.http.put<ApiResponse<void>>(this.apiUrl, data);
  }

  deleteTemplate(id: string): Observable<ApiResponse<void>> {
    return this.http.delete<ApiResponse<void>>(`${this.apiUrl}/${id}`);
  }

  setDefault(id: string): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.apiUrl}/${id}/set-default`, {});
  }

  preview(request: CommunicationTemplatePreviewRequest): Observable<ApiResponse<CommunicationTemplatePreview>> {
    return this.http.post<ApiResponse<CommunicationTemplatePreview>>(`${this.apiUrl}/preview`, request);
  }
}
